import React from 'react'
import createClass from 'create-react-class'
import ExtensionService from 'live/services/extension'
import ValidationMixin from 'live/components/forms/mixins/validation-mixin'
import ObjectInitializerMixin from 'live/components/forms/mixins/object-initializer'
import FormBase from 'live/components/extensions/ui/form'

import Form from './Form'

export interface ServiceBusSettings {
    enableForInput: boolean
    host: string
    topic: string
    subscription: string
    typeField: string
    consumeFromBeginning?: boolean
    enableStackTraceLog?: boolean
}

const BaseForm = createClass({
    mixins: [
        ObjectInitializerMixin('/rest/extension', {
            type: 'service-bus',
            active: true,
            config: {
                // routing: '',
                enableForInput: true,
                host:
                    'Endpoint=sb://${job.servicebus.windows.net}/;SharedAccessKeyName=${userWithPermissionRead};SharedAccessKey=${token}',
                topic: 'BasicTopic',
                subscription: 'Subscription',
                // consumeFromBeginning: true,
                typeField: 'events_servicebus'                
                // host:
                //     'Endpoint=sb://pepsico.servicebus.windows.net/;SharedAccessKeyName=RootManageSharedAccessKey;SharedAccessKey=PxZI+gMiJc1lAN7yCETSWnSG0lF/HNriozEGjbi5vvs=',
                // topic: 'pepsico-topic',
                // subscription: 'pepsico-topic-subscription',
                // consumeFromBeginning: true,
                // typeField: '__type'
            } as ServiceBusSettings,
            fullQualifier: null,
            qualifier: null,
            status: {}
        }),
        ValidationMixin
    ],
    validations: {},
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        window.location.href = '#/integrations/'
    },
    onChangeLabels: function (newLabels) {
        var object = this.state.object,
            config = object.config
        config.labels = newLabels
        this.applyObj({ config: config })
    },
    render: function () {
        const config = this.state.object.config as ServiceBusSettings

        return (
            <FormBase self={this}>
                <Form
                    config={config}
                    onChange={this.handleValidation}
                    errorsFor={this.errorsFor}
                    validationState={this.validationState}
                />
            </FormBase>
        )
    }
})

ExtensionService.register({
    name: 'service-bus',
    type: 'service-bus',
    origin: 'Plugin Service Bus',
    roles: ['input'],
    icon: '/content/plugin-service-bus/logo.png',
    ui: {
        form: BaseForm,
        view: null
    }
})
